// Campus photo for /colleges/college-of-william-and-mary: CC BY-SA 4.0, by Smash the Iron Cage, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3AWren_Building_West_Exposure.jpg), checked 2026-10-02 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/college-of-william-and-mary/; credited under the photo.
const photo = {
    "slug": "college-of-william-and-mary",
    "alt": "The brick Wren Building behind a white picket fence at William and Mary in Williamsburg, Virginia",
    "src": "/colleges/college-of-william-and-mary/campus-1600.webp",
    "srcSmall": "/colleges/college-of-william-and-mary/campus-800.webp",
    "srcMid": "/colleges/college-of-william-and-mary/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/college-of-william-and-mary/og.jpg",
    "title": "Wren Building West Exposure",
    "author": "Smash the Iron Cage",
    "license": "CC BY-SA 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3AWren_Building_West_Exposure.jpg",
    "read": "2026-10-02"
};

export default photo;
